import { EnumsInterface } from "@/interfaces/EnumsInterface";

const Gender:EnumsInterface[] = [
    {id: 0, value: 0, label: "Male"},
    {id: 1, value: 1, label: "Female"},
    {id: 2, value: 2, label: "LGBTQI+"},
]

export default Gender